import { PluginKey } from 'prosemirror-state';

import { getSanitisedUrl } from '@lyearn/core/utils/url';
import { EditorView } from '@lyearn/lygo-core';

import { getIframeSrc } from '../../components/EmbedPopover/utils';
import {
  getCurrentSelectionPMViewDesc,
  insertNode,
  selectionType,
  setPluginMeta,
  setSelection,
} from '../../utils';
import { clickFunction } from '../BlockMenu/types';

export const linkMenuKey = new PluginKey('link-menu-plugin');

export const hideLinkMenu = (view: EditorView) => {
  if (linkMenuKey.getState(view.state)?.open) {
    let LinkMenuProps = {
      open: false,
      url: null,
    };
    setPluginMeta(view, linkMenuKey, LinkMenuProps);
  }
};

export const onDismissClick: clickFunction = (_open, _anchorEl, view) => {
  hideLinkMenu(view);
};

const getCurrentPMViewDesc = (view: EditorView) => {
  const props = linkMenuKey.getState(view.state);
  const newSelection = view.state.selection.from - props.url.length;
  removeUrl(view, props.url);
  setSelection(view, selectionType.TEXT, newSelection);
  return getCurrentSelectionPMViewDesc(view, newSelection);
};

export const onEmbedClick: clickFunction = (_open, _anchorEl, view) => {
  const props = linkMenuKey.getState(view.state);
  const viewDesc = getCurrentPMViewDesc(view);
  insertNode(
    view,
    selectionType.NODE,
    view.state.schema.nodes.embed.create({
      embedUrl: getSanitisedUrl(getIframeSrc(props.url).parsedUrl),
    }),
    viewDesc.posAtEnd,
  );
  hideLinkMenu(view);
};

export const onBookmarkClick: clickFunction = (_open, _anchorEl, view) => {
  const props = linkMenuKey.getState(view.state);
  const viewDesc = getCurrentPMViewDesc(view);
  insertNode(
    view,
    selectionType.NODE,
    view.state.schema.nodes.webbookmark.create({ url: getSanitisedUrl(props.url) }),
    viewDesc.posAtEnd,
  );
  hideLinkMenu(view);
};

export const removeUrl = (view: EditorView, url: string) => {
  view.dispatch(
    view.state.tr.replace(view.state.selection.from - url.length, view.state.selection.from),
  );
};
